
import { Icon } from "@iconify/react";
import React, { useState } from "react";

export default function CustomInputProduct({
  title,
  type,
  subtitle,
  leftImg,
  rightImg,
  placeHolder = "",
  fontSize = 20,
  value = "",
  onChange = () => {},
  onClick = () => {},
  onEnter = () => {},
  data = [],
  disable = false,
}) {
  const [showSelect, setshowSelect] = useState(false);
  const [searchText, setsearchText] = useState("");
  return subtitle != null ? (
    <div
      onClick={() => {
        if (type == "check") {
          onClick();
        }
      }}
      className={
        "flex flex-row items-center gap-2 bg-[#F9F9F9] border-[1px] rounded-md " +
        (type == "check" ? "hover:cursor-pointer select-none" : "")
      }
    >
      {type == "check" ? (
        <img
          src={
            value ? "/img/CheckboxChecked.png" : "/img/CheckboxUnchecked.png"
          }
          className="w-5 object-contain"
        />
      ) : null}
      <div
        style={{ fontSize }}
        className=" h-full bg-[#F9F9F9] text-[#2E2E2E] text-[16px] font_Kanit font-semibold py-1 px-5 text-right"
      >
        {title}
      </div>
      {subtitle ? (
        <div
          style={{ fontSize }}
          className=" h-full bg-[#F9F9F9] text-[#2E2E2E] text-[16px] font_Kanit font-semibold py-1 px-5 flex-1 text-right"
        >
          {subtitle}
        </div>
      ) : null}
    </div>
  ) : (
    <div className="flex flex-row items-center gap-0 bg-white border-[1px] rounded-md w-full ">
      {title?<div
        style={{ fontSize }}
        className=" h-full flex flex-col justify-center bg-[#F9F9F9] text-[#2E2E2E] text-[16px] font_Kanit font-semibold py-1 px-3 w-52 text-right"
      >
        {title} 
      </div>:null}
      {leftImg ? (
        <div
          onClick={() => {}}
          className="active:opacity-50 hover:opacity-80 cursor-pointer ml-2 "
        >
          <img
            src={leftImg}
            className="object-contain "
            style={{ width: fontSize, height: fontSize }}
          />
        </div>
      ) : null}
      {type == "select" ? (
        <div className="relative w-full">
          <div className="flex-[1] flex flex-row items-center cursor-pointer  ">
            <div
              className={
                "flex-[1] font_Kanit font-medium px-1 " +
                (value?.name ? "text-center" : "")
              }
              style={{ fontSize: fontSize }}
              // onClick={() => {
              //   setshowSelect(!showSelect);
              // }}
            >
              <input
                value={showSelect ? searchText : value?.name}
                onChange={(e) => {
                  setsearchText(e.target.value);
                }}
                onClick={() => {
                  setshowSelect(!showSelect);
                }}
                type="text"
                className="font_Kanit font-medium text-left flex-1 w-full px-1  py-1 rounded-sm "
                style={{ fontSize: fontSize }}
                placeholder={placeHolder}
              />
              {/* {value?.name ? value.name : placeHolder} */}
            </div>
            <div
              className="px-2 text-lg "
              onClick={() => {
                setshowSelect(!showSelect);
                setsearchText("");
              }}
            >
              <Icon icon={showSelect ? "uis:angle-up" : "uis:angle-down"} />
            </div>
          </div>
          {showSelect ? (
            <div className="absolute left-0 z-[999] top-[35px] drop-shadow-md rounded-md w-full px-1 py-3 bg-white font_Kanit font-medium overflow-auto max-h-40">
              {data?.map((item, i) => {
                if (
                  searchText == "" ||
                  item?.name
                    ?.toLocaleLowerCase()
                    .search(searchText.toLocaleLowerCase()) > -1
                )
                  return (
                    <div
                      key={i}
                      className="hover:bg-[#2271B1] w-full hover:text-white text-center font_Kanit font-medium hover:cursor-pointer"
                      onClick={() => {
                        onChange(item);
                        setshowSelect(false);
                      }}
                    >
                      {item.name}
                    </div>
                  );
              })}
            </div>
          ) : null}
        </div>
      ) : type == "date" ? (
        <input
          defaultValue={value}
          value={value}
          onChange={(e) => {
            if (onChange != null) {
              console.log('e.target.value',e.target.value)
              onChange(e.target.value);
            }
          }}
          disabled={disable}
          type="date"
          className="font_Kanit font-medium text-left flex-1 min-w-[70%] px-2 disabled:bg-disable py-1 rounded-sm "
          style={{ fontSize: fontSize }}
          placeholder={placeHolder}
          onKeyDown={(event) => {
            if (event.key.toLocaleLowerCase() == "enter") {
              if (onEnter != null) {
                onEnter();
              }
            }
          }}
        />
      ) : (
        <input
          value={value}
          onChange={(e) => {
            if (onChange != null) {
              onChange(e.target.value);
            }
          }}
          disabled={disable}
          type="text"
          className="font_Kanit font-medium text-left flex-1 min-w-[70%] px-2 disabled:bg-disable py-1 rounded-sm "
          style={{ fontSize: fontSize }}
          placeholder={placeHolder}
          onKeyDown={(event) => {
            if (event.key.toLocaleLowerCase() == "enter") {
              if (onEnter != null) {
                onEnter();
              }
            }
          }}
        />
      )}

      {rightImg ? (
        <div
          onClick={() => {}}
          className="active:opacity-50 hover:opacity-80 cursor-pointer mr-2 "
        >
          <img
            src={rightImg}
            className="object-contain "
            style={{ width: fontSize, height: fontSize }}
          />
        </div>
      ) : null}
    </div>
  );
}
